define.alias("ember-composable-helpers/helpers/repeat", "calendar/helpers/repeat");